Router = App.loadClass 'core::Router'

class exports.ToolsRouter extends Router

    prefix: 'Tools'
    module_name: 'ToolsRouter'

    register: () ->
        @module = angular.module @module_name, ['ui.router', 'ui.bootstrap']

        # Manage Users
        @service 'admin::Angular/Tools/ManageUsers/ManageUsersService', ['$http', '$rootScope']
        @controller 'admin::Angular/Tools/ManageUsers/ManageUsersController', [
            '$scope'
            '$transitions'
            '$uibModal'
            'Tools.Services.ManageUsersService'
            '$window'
            '$http'
        ]
        @controller 'admin::Angular/Tools/ManageUsers/ViewAccountInfoController', [
            '$scope'
            '$transitions'
            '$uibModal'
            '$uibModalInstance'
            'Tools.Services.ManageUsersService'
            'account'
        ]
        @controller 'admin::Angular/Tools/ManageUsers/EditCompaniesController', [
            '$scope'
            '$transitions'
            '$uibModalInstance'
            'Tools.Services.ManageUsersService'
            'associations'
        ]
        @controller 'admin::Angular/Tools/ManageUsers/EditContactInfoController', [
            '$scope'
            '$transitions'
            '$uibModalInstance'
            'Tools.Services.ManageUsersService'
            'contact'
        ]
        @controller 'admin::Angular/Tools/ManageUsers/EditRolesController', [
            '$scope'
            '$transitions'
            '$uibModalInstance'
            'Tools.Services.ManageUsersService'
            'roles'
        ]

        # SMS Log
        @service 'admin::Angular/Tools/SmsLogService', ['$http', '$rootScope']
        @controller 'admin::Angular/Tools/SmsLogController', [
            '$scope'
            '$transitions'
            'Tools.Services.SmsLogService'
            '$window'
            '$http'
        ]

        # SMS Resubscribe
        @service 'admin::Angular/Tools/SmsResubscribeService', ['$http', '$rootScope']
        @controller 'admin::Angular/Tools/SmsResubscribeController', [
            '$scope'
            '$transitions'
            'Tools.Services.SmsResubscribeService'
            '$window'
            '$http'
        ]

        # Generate Key Fields
        @service 'admin::Angular/Tools/GenerateKeyFieldsService', ['$http', '$rootScope']
        @controller 'admin::Angular/Tools/GenerateKeyFieldsController', [
            '$scope'
            '$transitions'
            'Tools.Services.GenerateKeyFieldsService'
            '$http'
        ]

        # Companies
        @service 'admin::Angular/Tools/CompaniesService', ['$http', '$rootScope']
        @controller 'admin::Angular/Tools/CompaniesController', [
            '$scope'
            '$transitions'
            '$uibModal'
            'Tools.Services.CompaniesService'
            '$http'
        ]
        @controller 'admin::Angular/Tools/NewCompanyController', [
            '$scope'
            '$transitions'
            '$uibModalInstance'
            'Tools.Services.CompaniesService'
        ]
        @controller 'admin::Angular/Tools/EditCompanyPagesController', [
            '$scope'
            '$transitions'
            '$uibModalInstance'
            'Tools.Services.CompaniesService'
            'company'
            'pages'
            'reports'
        ]
        @controller 'admin::Angular/Tools/EditCompanyLineupsController', [
            '$scope'
            '$transitions'
            '$uibModal'
            '$uibModalInstance'
            'Tools.Services.CompaniesService'
            'company'
            'lineups'
            'crops'
            'seedCompanies'
        ]
        @controller 'admin::Angular/Tools/SeedCompanyDialogController', [
            '$scope'
            '$transitions'
            '$uibModalInstance'
            'Tools.Services.CompaniesService'
            '$q'
            '$http'
        ]

        # Bushels
        @service 'admin::Angular/Tools/BushelsService', ['$http', '$rootScope']
        @controller 'admin::Angular/Tools/BushelsController', [
            '$scope'
            '$transitions'
            '$uibModal'
            'Tools.Services.BushelsService'
            '$q'
            '$http'
        ]

        # Chemicals
        @service 'admin::Angular/Tools/ChemicalsService', ['$http', '$rootScope']
        @controller 'admin::Angular/Tools/ChemicalsController', [
            '$scope'
            '$transitions'
            '$uibModal'
            'Tools.Services.ChemicalsService'
            '$q',
            'Core.Services.Loading'
            '$http'
        ]
        @controller 'admin::Angular/Tools/ChemicalsChildrenController', [
            '$scope'
            '$transitions'
            '$uibModalInstance'
            'Tools.Services.ChemicalsService'
            'chemical'
            'chemicals'
        ]

        @service 'admin::Angular/Tools/Uploads/UploadsService', ['$http', '$rootScope']
        @controller 'admin::Angular/Tools/Uploads/UploadsController', [
            '$scope',
            '$transitions',
            'Tools.Services.UploadsService'
            '$http'
        ]

        # SPP Analysis
        @module.filter 'numFilter', () ->

            (collection, text) ->
                # Skip processing if there's no search input
                return collection unless text isnt ''

                # Here we search the collection for a match and return
                # the new list.
                list = []

                for num, i in collection

                    num = num.toString()
                    list.push(num) if num.indexOf(text) isnt -1

                return list

        @service 'admin::Angular/Tools/SppAnalysisService', ['$http', '$rootScope']
        @controller 'admin::Angular/Tools/SppAnalysisController', [
            '$scope'
            '$transitions'
            'Tools.Services.SppAnalysisService'
            '$window'
            '$http'
        ]

        # Slack Files
        @service  'admin::Angular/Tools/SlackFiles/SlackFilesService', [
            '$http'
            '$rootScope'
        ]

        @controller  'admin::Angular/Tools/SlackFiles/SlackFilesController', [
            '$scope',
            '$transitions'
            'Tools.Services.SlackFilesService'
            '$q'
            '$http'
        ]

        # Validation Example
        @service  'admin::Angular/Tools/ValidationExample/ValidationExampleService', [
            '$http'
            '$rootScope'
        ]

        @controller  'admin::Angular/Tools/ValidationExample/ValidationExampleController', [
            '$scope',
            '$transitions'
            'Tools.Services.ValidationExampleService'
            '$q'
            '$http'
        ]


    registerRoutes: ($stateProvider) ->
        $stateProvider
            .state 'admin.tools',
                url: '/tools'
                templateUrl: 'backend/admin/new-tools/sidebar'
                controller: ['$scope', '$state', ($scope, $state) ->
                    $scope.show_fullpage = true
                ]

            .state 'admin.tools.manage_users',
                url: '/manage-users'
                views:
                    fullpage:
                        templateUrl: 'backend/admin/new-tools/manage-users'
                        controller: 'Tools.Controllers.ManageUsersController'

            .state 'admin.tools.sms_log',
                url: '/sms-log'
                views:
                    fullpage:
                        templateUrl: 'backend/admin/new-tools/sms-log/dialog'
                        controller: 'Tools.Controllers.SmsLogController'

            .state 'admin.tools.sms_resubscribe',
                url: '/sms-resubscribe'
                views:
                    fullpage:
                        templateUrl: 'backend/admin/new-tools/sms-resubscribe/dialog'
                        controller: 'Tools.Controllers.SmsResubscribeController'

            .state 'admin.tools.generate_key_fields',
                url: '/generate-key-fields'
                views:
                    fullpage:
                        templateUrl: 'backend/admin/new-tools/generate-key-fields/dialog'
                        controller: 'Tools.Controllers.GenerateKeyFieldsController'

            .state 'admin.tools.companies',
                url: '/companies'
                views:
                    fullpage:
                        templateUrl: 'backend/admin/new-tools/companies/dialog'
                        controller: 'Tools.Controllers.CompaniesController'

            .state 'admin.tools.bushels',
                url: '/bushels'
                views:
                    fullpage:
                        templateUrl: 'backend/admin/new-tools/bushels/dialog'
                        controller: 'Tools.Controllers.BushelsController'

            .state 'admin.tools.chemicals',
                url: '/chemicals'
                views:
                    fullpage:
                        # This is not the blade template. This is the php controller.
                        # It is found at http/Controllers/Admin/NewTools.
                        # Chemicals.php is the file name, dialog is a method inside.
                        # That controller loads the view.
                        templateUrl: 'backend/admin/new-tools/chemicals/dialog'
                        # This is the angular controller found in Admin/Angular/Tools.
                        # There is no "Controllers" folder in the directory structure.
                        controller: 'Tools.Controllers.ChemicalsController'

            .state 'admin.tools.spp_analysis',
                url: '/spp-analysis'
                views:
                    fullpage:
                        templateUrl: 'backend/admin/spp-analysis/dialog'
                        controller: 'Tools.Controllers.SppAnalysisController'

            .state 'admin.tools.slack_files',
                url: '/slack-files'
                views:
                    fullpage:
                        templateUrl: 'backend/admin/slack-files/dialog'
                        controller: 'Tools.Controllers.SlackFilesController'

            .state 'admin.tools.validation_example',
                url: '/validation-example'
                views:
                    fullpage:
                        templateUrl: 'backend/admin/validation-example/view'
                        controller: 'Tools.Controllers.ValidationExampleController'

            .state 'admin.tools.uploads',
                url: '/uploads'
                views:
                    fullpage:
                        templateUrl: 'backend/admin/new-tools/uploads/dialog'
                        controller: 'Tools.Controllers.UploadsController'
